export enum ProductionArea {
  Grinding = "Grinding",
  HPR = "HPR",
  Hoisting = "Hoisting",
}
